var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useImmer } from 'use-immer';
import { XFormInputEmail } from '../components/form/XFormInputEmail';
import { XFormInputCurrency } from '../components/form/XFormInputCurrency';
import { XFormInputCheckbox } from '../components/form/XFormInputCheckbox';
import { XFormInputText } from '../components/form/XFormInputText';
import { XFormInputPhone } from '../components/form/XFormInputPhone';
import { XFormInputNumber } from '../components/form/XFormInputNumber';
import { isNumber } from '../../util/isNumber';
import { XFormInputTextarea } from '../components/form/XFormInputTextarea';
import { XFormInputEditor } from '../components/form/XFormInputEditor';
import { XFormInputSelect } from '../components/form/XFormInputSelect';
export function useForm(fields, options) {
    var _a = useImmer(getInitialValue()), data = _a[0], setFormData = _a[1];
    function getInitialValue() {
        var _a;
        var form = {};
        for (var _i = 0, _b = Object.keys(fields); _i < _b.length; _i++) {
            var field = _b[_i];
            form[field] = ((_a = fields[field]) === null || _a === void 0 ? void 0 : _a.value) || undefined;
        }
        return form;
    }
    function setDataValue(field, value) {
        setFormData(function (form) {
            form[field] = value;
        });
    }
    return {
        data: data,
        getData: function () {
            var values = {};
            for (var _i = 0, _a = Object.keys(fields); _i < _a.length; _i++) {
                var field = _a[_i];
                var type = fields[field].type;
                var value = data[field];
                if (['currency', 'number'].includes(type)) {
                    var asNumber = Number(value);
                    if (value !== '' && isNumber(asNumber)) {
                        if (type === 'currency') {
                            values[field] = asNumber;
                            //values[field] = Math.round(asNumber * 100);
                        }
                        else {
                            values[field] = asNumber;
                        }
                    }
                    else {
                        values[field] = undefined;
                    }
                }
                else {
                    values[field] = data[field];
                }
            }
            return values;
        },
        getPhoneFieldValue: function (field) {
            return data[field];
        },
        getFormElement: function (children) {
            return (React.createElement("form", { onSubmit: function (event) {
                    event.preventDefault();
                    options === null || options === void 0 ? void 0 : options.onSubmit(__assign({}, data));
                } }, children));
        },
        getInputElement: function (field) {
            var inputProps = fields[field];
            var Component = {
                checkbox: XFormInputCheckbox,
                currency: XFormInputCurrency,
                editor: XFormInputEditor,
                email: XFormInputEmail,
                number: XFormInputNumber,
                phone: XFormInputPhone,
                select: XFormInputSelect,
                text: XFormInputText,
                textarea: XFormInputTextarea,
            }[inputProps.type];
            if (!Component) {
                return React.createElement("div", null, "Unknown input");
            }
            return (React.createElement(Component, __assign({}, inputProps, { value: data[field], onChange: function (value) {
                    setDataValue(field, value);
                } })));
        },
        setFieldValue: function (field, value) {
            setDataValue(field, value);
        },
        reset: function () {
            setFormData(function () { return getInitialValue(); });
        },
    };
}
